import React, { useState } from 'react';
import './PasswordInput.css';

// A password field with an eye button to show or hide what is typed. Takes the same props as <input>.
export default function PasswordInput(props) {
  const [shown, setShown] = useState(false);
  return (
    <span className="pw-field">
      <input {...props} type={shown ? 'text' : 'password'} />
      <button
        type="button"
        className="pw-toggle"
        onClick={() => setShown((s) => !s)}
        aria-label={shown ? 'Hide password' : 'Show password'}
        aria-pressed={shown}
        title={shown ? 'Hide password' : 'Show password'}
        disabled={props.disabled}
      >
        <i className={`bi ${shown ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true" />
      </button>
    </span>
  );
}
